import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type InfoBannerMode = 'information' | 'warning';

@Component({
  selector: 'app-info-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-banner.component.html',
  styleUrl: './info-banner.component.scss',
})
export class InfoBannerComponent {
  @Input() mode: InfoBannerMode = 'information';
  @Input() title: string | null = null;
  @Input() description: string | null = null;

  get iconClass(): string {
    return this.mode === 'warning'
      ? 'fas fa-triangle-exclamation'
      : 'fas fa-circle-info';
  }
}
